<template>
  <p class="Paragraph" :class="className"><slot></slot></p>
</template>

<script>
import cx from "classnames";

export default {
  name: "Paragraph",
  props: {
    last: Boolean
  },
  computed: {
    className() {
      return cx({
        last: this.last
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.Paragraph {
  &.last {
    margin-bottom: 0;
  }
}
</style>
